import { getAuthHeader } from '.';
import { ROOT_URL } from '../utils/constants';
import type { PublicProfileName } from '../models/PublicProfileName';

class PublicProfileApi {
  static async setPublicProfile(publicProfile: PublicProfileName) {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/publicprofile`, {
      method: 'POST',
      credentials: 'include',
      headers: headers,
      body: JSON.stringify(publicProfile),
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async updatePublicProfile(publicProfile: PublicProfileName) {
    const [headers] = await getAuthHeader();
    const response = await fetch(
      `${ROOT_URL}/api/publicprofile/${publicProfile.publicProfileNameId}`,
      {
        method: 'PUT',
        credentials: 'include',
        headers: headers,
        body: JSON.stringify(publicProfile),
      },
    );
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async getPublicProfile() {
    const [headers, userDetails] = await getAuthHeader();
    const response = await fetch(
      `${ROOT_URL}/api/publicprofile/${userDetails?.userId}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: headers,
      },
    );
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    if (response.body && response.status !== 204) {
      return response.json();
    }
    return {};
  }
  static async getPublicGallery(profileName: string) {
    const [headers] = await getAuthHeader();
    const response = await fetch(
      `${ROOT_URL}/api/publicprofile/${profileName}/gallery`,
      {
        method: 'GET',
        credentials: 'include',
        headers: headers,
      },
    );
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
}

export default PublicProfileApi;
